import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { DialogType } from '../DialogHandler';
import { viewSlice } from '../features/view/viewSlice';
import { Button } from './Button';
import { Dialog } from './Dialog';

import './Login.css';

export const Login = (props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  return (
    <Dialog title={t('LOGIN')} className="login">
      <form onSubmit={(e) => { dispatch({ type: 'action/login', payload: {username: username, password: password, roomID: props.roomID} }); e.preventDefault();}}>
        <table>
          <tbody>
            <tr><td className="name">{t('USERNAME')}:</td><td><input type="text" value={username} onChange={e => setUsername(e.target.value)} autoCapitalize="none" autoCorrect="off" spellCheck="false" autoComplete="off" /></td></tr>
            <tr><td className="name">{t('PASSWORD')}:</td><td><input type="text" value={password} onChange={e => setPassword(e.target.value)} autoCapitalize="none" autoCorrect="off" spellCheck="false" autoComplete="off" /></td></tr>
            <tr><td className="name"></td><td><Button type="submit">{t('LOGIN')}</Button> <Button type="button" onClick={(e) => dispatch(viewSlice.actions.closeDialog(DialogType.LOGIN))}>{t('ABORT')}</Button></td></tr>
          </tbody>
        </table>
      </form>
    </Dialog>
  );
}